import { Image } from '@app/components'
import React from 'react'

export const EuropeanFlagIcon = () => {
  return <Image preview={false} src="../images/european-flag.png" />
}
